// for imports in other files
export const ACTION_PREFIX = 'PROFILE_EDIT';
export const STATE_NAME = 'profileEdit';

export enum ActionTypes {
  loadUserStart = 'PROFILE_EDIT/LOAD_USER_START',
  loadUserFail = 'PROFILE_EDIT/LOAD_USER_FAIL',
  loadUserDone = 'PROFILE_EDIT/LOAD_USER_DONE',
  updateUser = 'PROFILE_EDIT/UPDATE_USER',
  submitFormFail = 'PROFILE_EDIT/SUBMIT_FORM_FAIL',
  updatePendingChanges = 'PROFILE_EDIT/UPDATE_PENDING_CHANGES',
}

export const Actions = {
  LOAD_USER_START: ActionTypes.loadUserStart,
  LOAD_USER_DONE: ActionTypes.loadUserDone,
  LOAD_USER_FAIL: ActionTypes.loadUserFail,

  UPDATE_USER: ActionTypes.updateUser,
  SUBMIT_FORM_FAIL: ActionTypes.submitFormFail,

  UPDATE_PENDING_CHANGES: ActionTypes.updatePendingChanges,
};
